import type { AbGroup, PartnerSignupInfo } from '@avalara/types/reducer-states';
import type { MouseEvent } from 'react';

export const catchNextClick = (e: MouseEvent, isDisabled: boolean): void => {
  if (isDisabled) e.preventDefault();
};

// only remove bullet point on group B (non QBO/QBD)
export const showThirdBullet = (abGroup: AbGroup, partnerSignup: PartnerSignupInfo) =>
  (abGroup !== null && abGroup === 'A') ||
  (partnerSignup !== null && (partnerSignup.code === 'QBO' || partnerSignup.code === 'QBD'));
